<template>
  <div class="batch-match-expert wrap-content">
    <div class="wrap-oper">
      <Button type="default" @click="back" class="save">返回</Button>
    </div>
    <div class="wrap-inner">
      <div class="wrap-form">
        <label class="form-label">学生信息</label>
        <div class="kh-table kh-table-default kh-table-border">
          <table cellspacing="0">
            <thead>
            <tr>
              <th><div class="kh-table-cell">学校</div></th>
              <th v-if="from!=='unit'"><div class="kh-table-cell">学号</div></th>
              <th v-if="from!=='unit'"><div class="kh-table-cell">姓名</div></th>
              <th><div class="kh-table-cell">一级学科</div></th>
              <th><div class="kh-table-cell">二级学科</div></th>
              <th><div class="kh-table-cell">论文涉及研究方向</div></th>
              <th><div class="kh-table-cell">论文题目</div></th>
              <th v-if="from!=='unit'"><div class="kh-table-cell">送审专家数</div></th>
              <th v-if="from!=='unit'"><div class="kh-table-cell">单位提交时间</div></th>
              <th v-if="from!=='unit'"><div class="kh-table-cell">送审专家数操作</div></th>
            </tr>
            </thead>
            <tbody>
            <tr class="kh-table-row">
              <td><div class="kh-table-cell">{{studentMsg.unitName}}</div></td>
              <td v-if="from!=='unit'"><div class="kh-table-cell">{{studentMsg.schoolNo}}</div></td>
              <td v-if="from!=='unit'"><div class="kh-table-cell">{{studentMsg.authorName}}</div></td>
              <td><div class="kh-table-cell">{{studentMsg.firstSubjectName}}</div></td>
              <td><div class="kh-table-cell">{{studentMsg.secondSubjectName}}</div></td>
              <td><div class="kh-table-cell">{{studentMsg.researchAera}}</div></td>
              <td><div class="kh-table-cell">{{studentMsg.titleCn}}</div></td>
              <td v-if="from!=='unit'"><div class="kh-table-cell">{{studentMsg.sendNum + '/' + studentMsg.auditExpertNum}}</div></td>
              <td v-if="from!=='unit'"><div class="kh-table-cell">{{studentMsg.submitTime}}</div></td>
              <td v-if="from!=='unit'"><div class="kh-table-cell">
                <span class="link-a">修改</span>
              </div></td>
            </tr>
            </tbody>
          </table>
        </div>
      </div>
      <div class="wrap-form">
        <label class="form-label">已送单位</label>
        <div class="kh-table kh-table-default kh-table-border">
          <table cellspacing="0">
            <thead>
            <tr>
              <th><div class="kh-table-cell">单位属性</div></th>
              <th><div class="kh-table-cell">单位名称</div></th>
              <th><div class="kh-table-cell">所属学院</div></th>
              <th><div class="kh-table-cell">联系人</div></th>
              <th><div class="kh-table-cell">联系电话</div></th>
              <th><div class="kh-table-cell">证件类型</div></th>
              <th><div class="kh-table-cell">证件号码</div></th>
              <th><div class="kh-table-cell">上级联系人</div></th>
              <th><div class="kh-table-cell">操作</div></th>
            </tr>
            </thead>
            <tbody>
            <tr class="kh-table-row" v-if="acceptUnit.id">
              <td><div class="kh-table-cell">{{acceptUnit.type=='1'?'学校':'其他'}}</div></td>
              <td><div class="kh-table-cell">{{acceptUnit.unitName}}</div></td>
              <td><div class="kh-table-cell">{{acceptUnit.department}}</div></td>
              <td><div class="kh-table-cell">{{acceptUnit.contactName}}</div></td>
              <td><div class="kh-table-cell">{{acceptUnit.contactTel}}</div></td>
              <td><div class="kh-table-cell">{{acceptUnit.idCardType}}</div></td>
              <td><div class="kh-table-cell">{{acceptUnit.identityCard}}</div></td>
              <td><div class="kh-table-cell">{{acceptUnit.parentName}}</div></td>
              <td><div class="kh-table-cell">
                <span v-if="studentMsg.reviewStatus!=='2'" class="link-a" @click="requestCancelSend(acceptUnit)">撤销</span>
              </div></td>
            </tr>
            </tbody>
          </table>
        </div>
      </div>
      <div class="wrap-form" v-if="!readonly && from!=='unit'">
        <label class="form-label">可送单位</label>
        <div class="">
          <regular-page ref="sendUnitPage"
                        v-if="!loading"
                        config-path="batchSendUnit"
                        :parent-id="currentId"
                        @reload="fetchDefaultMessage"
          ></regular-page>
        </div>
      </div>
      <div class="wrap-form" v-if="!readonly && from==='unit'">
        <label class="form-label">可送学院<span class="tips" @click="employer.show = true">找不到学院？点此新增学院</span></label>
        <div class="">
          <regular-page ref="sendUnitPage"
                        v-if="!loading"
                        config-path="sendUnit"
                        :parent-id="currentId"
                        @reload="fetchDefaultMessage"
          ></regular-page>
        </div>
      </div>
      <Spin size="large" fix v-if="loading"></Spin>

      <Modal v-model="employer.show"
             title="新增学院"
             @on-ok="dialogOK"
             :loading="employer.loading"
      >
        <employer-edit2 ref="employerEdit" v-if="employer.show"></employer-edit2>
      </Modal>
    </div>
  </div>
</template>

<script>
import regularPage from '../../regularPage'
import EmployerEdit2 from '../../dialogs/systemManage/employerEdit2'
export default {
  name: 'matchUnit',
  components: {regularPage, EmployerEdit2},
  props: {
    query: ''
  },
  data () {
    return {
      currentId: '',
      studentMsg: {},
      acceptUnit: {},
      typeMap: {
        0: '其他',
        1: '博士生导师',
        2: '硕士生导师',
        3: '兼职博士生导师',
        4: '兼职硕士生导师'
      },
      positionMap: {
        '00': '无',
        '01': '初级',
        '02': '中级',
        '03': '副高级',
        '04': '正高级',
        '05': '讲师(博士学位)',
        '06': '副教授',
        '07': '教授'
      },
      employer: {
        show: false,
        loading: true
      },
      loading: true
    }
  },
  created () {
    this.currentId = this.query.split('&')[0].split('id=')[1] || this.$route.query.id;
    this.readonly = this.query.includes('readonly');

    this.from = this.query.split('from=')[1] || this.$route.query.from;
    if (this.from === 'unit') {
    }

    this.fetchDefaultMessage();
  },
  watch: {
  },
  methods: {
    // 获取学生信息
    fetchDefaultMessage () {
      const _self = this;
      _self.loading = true;
      let url = '/custom/sendPaper/info/';
      if (_self.from === 'unit') {
        url = '/school/schoolDegreeOffice/info/';
      }
      _self.post(url + _self.currentId).then(res => {
        _self.studentMsg = res.data;
        _self.acceptUnit = res.data.secondZpdw || {};
        _self.loading = false;
      }).catch(() => {
        _self.loading = false;
      });
    },
    // 发送请求取消送审
    requestCancelSend (acceptUnit) {
      let url = '/custom/sendPaper/delete';
      let param = {};
      if (this.from === 'unit') {
        url = '/school/schoolDegreeOffice/deleteSendAcademy';
        param = {id: this.studentMsg.expReviewId};
      } else {
        param = {id: acceptUnit.expReviewInfoId, paperId: this.currentId};
      }
      this.post(url, param).then(res => {
        this.$Message.success('取消成功！');
        this.fetchDefaultMessage();
      })
    },
    dialogOK () {
      const _self = this;
      _self.$refs['employerEdit'].dialogComfirm().then(val => {
        // 确定成功后重刷页面
        _self.employer.show = false;
        _self.fetchDefaultMessage();
      }).catch((error) => {
        if (error.code === 500) {
          _self.employer.show = false;
          _self.fetchDefaultMessage();
        } else {
          _self.employer.loading = false;
          _self.$nextTick(function () {
            _self.employer.loading = true;
          })
        }
      });
    },
    back () {
      this.$emit('back');
    }
  }
}
</script>
<style lang="less">
  .batch-match-expert {
    .kh-table-body {
      td.kh-table-expanded-cell {
        padding: 10px;
      }
    }

  }
</style>
<style lang="less" scoped>
  .batch-match-expert {
    .kh-table {
      table {
        table-layout: auto;
        width: 100%;
        th {
          border-top: 1px solid #e8eaec;
          .kh-table-cell {
            white-space: nowrap;
          }
          &:first-child {
            border-left: 1px solid #e8eaec;
          }
        }
        td {
          &:first-child {
            border-left: 1px solid #e8eaec;
          }
        }
        .link-span {
          cursor: pointer;
          text-decoration: underline;
        }
        .link-a {
          color: @link-color;
          cursor: pointer;
        }
      }
    }
    .form-label {
      .tips {
        color: @base-color;
        cursor: pointer;
        font-size: @font-size-small;
        font-weight: normal;
        margin-left: 20px;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/layout/customPage/thesisManage/matchUnit.vue